import { render, staticRenderFns } from "./CodeDisplay.vue?vue&type=template&id=1de079cc&"
import script from "./CodeDisplay.vue?vue&type=script&lang=js&"
export * from "./CodeDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CodeDisplay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports